import { useEffect, useState } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import roomMessagesService from '../services/roomMessagesService'
import { webSocketService } from '../services/websocket'

export function useRoomMessenger(roomId: string | undefined) {
  const queryClient = useQueryClient()
  const [showMessengerModal, setShowMessengerModal] = useState(false)
  const [unreadMessageCount, setUnreadMessageCount] = useState(0)

  const unreadQuery = useQuery({
    queryKey: ['room-unread', roomId],
    queryFn: () => roomMessagesService.unreadCount(roomId!),
    enabled: !!roomId,
    staleTime: 30_000,
  })

  useEffect(() => {
    if (typeof unreadQuery.data === 'number') {
      setUnreadMessageCount(unreadQuery.data)
    }
  }, [unreadQuery.data])

  useEffect(() => {
    if (!roomId) return
    webSocketService.connectForRoom(roomId)
    const onNew = () => {
      if (!showMessengerModal) {
        setUnreadMessageCount((c) => c + 1)
        queryClient.invalidateQueries({ queryKey: ['room-unread', roomId] })
      }
    }
    webSocketService.on('room:message:new', onNew)
    return () => {
      webSocketService.off('room:message:new', onNew)
      webSocketService.leaveRoom(roomId)
    }
  }, [roomId, showMessengerModal, queryClient])

  return {
    showMessengerModal,
    setShowMessengerModal,
    unreadMessageCount,
    setUnreadMessageCount,
  }
}
